import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Button, Container, Grid, TextField, Typography } from "@mui/material";
import RtlProvider from '../../../Components/RtlProvider';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import gregorian from "react-date-object/calendars/gregorian"
import gregorian_en from "react-date-object/locales/gregorian_en"

import { ContextNotification, severitys } from '../../../App';
import reservationApi from '../../../api/reservationApi';
import helper from '../../../helper';
import planApi from '../../../api/planApi';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import BrokerApi from '../../../api/brokerApi';

import hotelApi from '../../../api/hotelApi';
import cityApi from '../../../api/cityApi';


import brokerApi from '../../../api/brokerApi';
import ChunkedPlanRooms from '../../../Components/ChunkedPlanRooms';
import stationApi from '../../../api/stationApi';
import staticVariablesApi from '../../../api/staticVariablesApi';
import hotelStructureApi from '../../../api/hotelStructureApi';
import brokerGroupApi from '../../../api/brokerGroupApi';
import { RHFAutocomplete2 } from '../../../Components/RHFAutocomplete2';
import BeatLoading from '../../../Components/Loader/BeatLoader';
import enumMapper from '../../../enumMapper';
import InitialPlanFooter from '../../../Components/InitialPlanFooter';
import moment from 'jalali-moment';

export const AddInitialPlan = () => {
    const { open, setOpen } = useContext(ContextNotification);

    const [Cities, setCities] = useState([]);
    const [Hotels, setHotels] = useState([]);
    const [hotelStructureIds, setHotelStructureIds] = useState([])
    const [HotelPlans, SetHotelPlans] = useState([]);
    const [Brokers, SetBrokers] = useState([]);
    const [brokerGroups, setBrokerGroups] = useState([]);
    const [CityInfo, setCityInfo] = useState(null);
    const [BrokerInfo, setBrokerInfo] = useState(null);
    const [FlightStations, SetFlightStations] = useState([])
    const [Airlines, SetAirlines] = useState([])
    const [HotelStructure, SetHotelStructure] = useState({});
    const [PlanInfoStructure, SetPlanInfoStructure] = useState(null)

    const [DispatchOfTheDayDropDown, SetDispatchOfTheDayDropDown] = useState([]);

    const [tripInfoForPLan, setTripInfoForPLan] = useState(null)
    const [CurrentDateTime, setCurrentDateTime] = useState('');
    const [submitLoading, setSubmitLoading] = useState(false);
    const schema = yup.object().shape({

        CityConsistency: yup.string().required("شهر را انتخاب نمایید"),
        hotelId: yup.string().required("هتل را انتخاب نمایید"),
        planID: yup.string().required("کد پلان ر انتخاب نمایید"),
        capacity: yup.number().positive("ظرفیت بزرگتر از صفر").integer().typeError("فرمت ظرفیت عددی").required("ظرفیت را وارد نمایید"),
        hotelStructureId: yup.string().required("ساختار را انتخاب نمایید"),
        brokerId: yup.string().required("کارگزار را انتخاب نمایید"),
        brokerGroupId: yup.string().required("گروه را انتخاب نمایید"),
    });
    const { register, setValue, handleSubmit, formState: { errors, isSubmitSuccessful }, control, watch, resetField } = useForm({
        defaultValues: {
            'firstDescription': '',
            'secondDescription': '',
            'thirdDescription': '',
            'planID': null,
            'flightDate': null,
            'airLineId': null,
            //'reservationStartDate': null,
            //'reservationEndtDate': null,
            'dispatchOfTheDay': null,
            'capacity': null,
            'flightStationOrigin': null,
            //'flightStationDestination':null
            'brokerId': null,
            'groupNumber': '',


        },
        resolver: yupResolver(schema),
    });
    const onSubmit = (data) => {
        setSubmitLoading(true);
        const newData = {
            "planID": data.planID,
            "dispatchOfTheDay": parseInt(data.dispatchOfTheDay),
            "firstDescription": data.firstDescription,
            "secondDescription": data.secondDescription,
            "thirdDescription": data.thirdDescription,
            "brokerGroupId": data.brokerGroupId,
            "requestedForCity": parseInt(data.CityConsistency),
            "capacity": data.capacity
        }
        reservationApi.UpdateInitialReservation(newData)
            .then((res) => {
                if (res.data.success) {
                    setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                    resetForm();
                }
                else {
                    setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
                }

            }).catch(err => {
                if (err.response) {
                    setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
                }
            }
            ).finally(() => { setSubmitLoading(false); });
    };
    useEffect(() => {

        GetCityDropDown();
        GetBrokerDropDown();
        GetFlightStationDropDown();
        GetAirlineDropDown();
        GetDispatchOfTheDayDropDown();

        staticVariablesApi.GetCurrentDateTime().then(res => {
            moment.locale('fa');
            setCurrentDateTime(moment.from(res.data, 'en', 'YYYY-MM-DD[T]HH:mm:ss[Z]').format('YYYY/MM/DD'));
        }).catch(err => console.log(err))

    }, []);
    const resetForm = () => {
        resetField("firstDescription");
        resetField("secondDescription");
        resetField("thirdDescription");

        resetField("flightDate");
        resetField("dispatchOfTheDay");
        resetField("capacity");
        resetField("flightStationOrigin");
        resetField("brokerGroupId");

        resetField("planID");
        resetField("CityConsistency");
        resetField("hotelId");
        resetField("brokerId");

        resetField("hotelStructureId")

        setHotels([]);
        SetHotelPlans([]);
        setCityInfo(null);
        setBrokerInfo(null);
        SetHotelStructure({});
        SetPlanInfoStructure(null)
        // setTripInfoForPLan(null)



    }

    const handleCityChanged = useCallback(async (option) => {
        resetField("hotelId");
        setHotels(null);
        setCityInfo(null);
        SetHotelStructure(null);
        if (option) {
            const hotels = await fetchHotelsByCityConsistency(option.id);
            setHotels(
                hotels.map((o) => {
                    return {
                        id: o.key,
                        label: o.value
                    };
                })
            );
            setCityInfo(option)

        }
    }, []);
    const handleHotelChanged = useCallback(async (id) => {
        // resetField("");      
        SetHotelStructure({});

        resetField("planID");
        SetPlanInfoStructure(null);

        setHotelStructureIds([]);
        if (id) {
            const hotelStructureIds = await fetchHotelStrutureDropDown(id);
            const arr = helper.DictionayToList(hotelStructureIds);
            const mappedReponse = arr.map((r) => {
                return {
                    id: r.key,
                    label: r.value
                };
            });
            setHotelStructureIds(mappedReponse);

            if (arr.length === 1) {
                setValue("hotelStructureId", arr[0].key);

                SetHotelStructure(null);
                const hotelStructure = await fetchHotelStructureById(arr[0].key);
                SetHotelStructure(hotelStructure);
                GetPlanHotelDropDown(arr[0].key);
            }
        }

    }, []);
    const handlePlanChanged = useCallback(async (id) => {
        // resetField("");

        SetPlanInfoStructure(null)
        if (id) {
            const planInfo = await fetchPlanInfoStructureByPlanId(id);


            SetPlanInfoStructure(planInfo)
        }
    }, []);


    const GetCityDropDown = () => {
        staticVariablesApi.GetArabicCityConsistencyDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data)
                const mappedReponse = arr.map((r) => {
                    return {
                        id: r.key,
                        label: r.value
                    };
                });
                setCities(mappedReponse);
            })
            .catch((error) => console.log(error));
    };
    const fetchHotelsByCityConsistency = async (cityConsistency) => {
        try {
            let res = await hotelApi.HotelDropDown(cityConsistency);
            if (res.status == 200) {
            }
            const arr = helper.DictionayToList(res.data.data)
            return arr;
        }
        catch (err) {
            console.error(err);
        }
    };
    const GetBrokerDropDown = () => {
        BrokerApi
            .BrokerDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data)
                SetBrokers(arr.map((r) => {
                    return {
                        id: r.key,
                        label: r.value
                    };
                }))
            })
            .catch((error) => console.log(error));
    };

    const GetFlightStationDropDown = () => {
        stationApi.GetAll()
            .then((res) => {
                SetFlightStations(res.data.data.map((r) => {
                    return {
                        id: r.id,
                        label: r.name
                    };
                }))
            })
            .catch((error) => console.log(error));
    };
    const GetAirlineDropDown = () => {
        staticVariablesApi.GetAirLineTypeDropDown()
            .then((res) => {
                const arr = helper.DictionayToList(res.data.data)
                SetAirlines(arr.map((r) => {
                    return {
                        id: r.value,
                        label: r.value
                    };
                }))
            })
            .catch((error) => console.log(error));
    };
    const fetchPlanInfoStructureByPlanId = async (planID) => {
        try {
            let res = await planApi.GetPlanInfoStructureByPlanId(planID)
            if (res.status == 200) {
            }
            return res.data.data;
        }
        catch (err) {
            console.error(err);
        }
    };

    const GetBorkerByKey = (id) => {
        return brokerApi.GetByKey(id).then(res => {
            setBrokerInfo(res.data.data);
        });
    }






    const GetDispatchOfTheDayDropDown = () => {
        reservationApi.GetDispatchOfTheDayDropDown()
            .then(res => {
                const arr = helper.DictionayToList(res.data.data)
                SetDispatchOfTheDayDropDown(arr.map((item) => {
                    return {
                        id: item.key,
                        label: item.value
                    };
                }))
            })
            .catch(err => console.log(err));
    }
    const handleDispatchOfTheDayChanged = (id) => { }

    const handleBrokerChanged = useCallback(async (id) => {
        setBrokerInfo(null)
        if (id) {
            GetBorkerByKey(id);
            const groupNumbers = await fetchBrokerGroupByBrokerId(id);
            setBrokerGroups(
                groupNumbers.map((o) => {
                    return {
                        id: o.key,
                        label: o.value
                    };
                })
            );
        }
    }, []);


    const handleHotelStructureIdChanged = async (id) => {

        // resetField("");
        SetHotelStructure(null);
        if (id) {

            const hotelStructure = await fetchHotelStructureById(id);
            SetHotelStructure(hotelStructure);
            GetPlanHotelDropDown(id);
        }
    };
    const fetchHotelStructureById = async (id) => {
        try {
            let res = await hotelStructureApi.GetHotelStructure(id);
            if (res.status == 200) {
            }
            return res.data.data;
        }
        catch (err) {
            console.error(err);
        }
    };
    const GetPlanHotelDropDown = (structureId) => {
        hotelStructureApi.PlanIdHotelStructureDropDown(structureId).then(res => {
            const arr = helper.DictionayToList(res.data.data);
            SetHotelPlans(arr.map((item) => {
                return {
                    id: item.key,
                    label: item.value
                };
            }));
        }).catch(err => console.log(err));
    };

    const fetchHotelStrutureDropDown = async (hotelId) => {
        try {
            let res = await hotelStructureApi.HotelStrutureDropDown(hotelId);
            if (res.status == 200) {
            }
            return res.data.data;
        }
        catch (err) {
            console.error(err);
        }
    };
    const handleBrokerGroupChanged = async (id) => {
        if (id) {
            GetBrokerGroupInfoByGroupId(id)
        }

    }
    const fetchBrokerGroupByBrokerId = async (brokerId) => {
        try {
            let res = await brokerGroupApi.BrokerGroupDropDown(brokerId);
            if (res.status == 200) {
            }
            const arr = helper.DictionayToList(res.data.data)
            return arr;
        }
        catch (err) {
            console.error(err);
        }
    };



    const GetBrokerGroupInfoByGroupId = (brokerGroupId) => {
        reservationApi.GetBrokerGroupInfoByGroupId(brokerGroupId).then(res => {
            setTripInfoForPLan(res?.data.data)
        }).catch(err => console.log(err));
    };
    return (
        <Container component="main" maxWidth={false}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <RtlProvider>
                    <Typography component="h1" variant="h5" mb={2}>افزودن پلان اقامتی کارگزار</Typography>
                    <Grid container spacing={1} sx={{ mb: 2 }}>
                        <Grid item xs={12} sm={1}>
                            <RHFAutocomplete2
                                loading={!Cities?.length}
                                control={control}
                                options={Cities ?? []}
                                name="CityConsistency"
                                placeholder="شهر"
                                onChange={handleCityChanged}
                                disabled={!Cities?.length}
                                error={!!errors?.CityConsistency}
                                helperText={errors?.CityConsistency?.message}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <RHFAutocomplete
                                loading={watch("CityConsistency") && !Hotels?.length}
                                control={control}
                                options={Hotels ?? []}
                                name="hotelId"
                                placeholder="هتل"
                                onChange={handleHotelChanged}
                                disabled={!Hotels?.length}
                                error={!!errors?.hotelId}
                                helperText={errors?.hotelId?.message}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <RHFAutocomplete
                                loading={watch("hotelId") && !hotelStructureIds?.length}
                                control={control}
                                options={hotelStructureIds ?? []}
                                name="hotelStructureId"
                                placeholder="ساختار"
                                onChange={handleHotelStructureIdChanged}
                                disabled={!hotelStructureIds?.length || hotelStructureIds?.length === 1}
                                style={{
                                    border: "none",
                                    padding: 0,
                                }}
                                error={!!errors?.hotelStructureId}
                                helperText={errors?.hotelStructureId?.message}
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <RHFAutocomplete
                                loading={watch("hotelStructureId") && !HotelPlans?.length}
                                control={control}
                                options={HotelPlans ?? []}
                                name="planID"
                                placeholder="پلان"
                                onChange={handlePlanChanged}
                                disabled={!HotelPlans?.length}
                                error={!!errors?.planID}
                                helperText={errors?.planID?.message}
                            />

                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <RHFAutocomplete
                                control={control}
                                options={Brokers ?? []}
                                name="brokerId"
                                placeholder="کارگزار"
                                onChange={handleBrokerChanged}
                                error={!!errors?.brokerId}
                                helperText={errors?.brokerId?.message}
                            />
                        </Grid>
                        <Grid item xs={12} sm={1}>
                            <RHFAutocomplete
                                control={control}
                                options={brokerGroups ?? []}
                                name="brokerGroupId"
                                placeholder="گروه"
                                onChange={handleBrokerGroupChanged}
                                error={!!errors?.brokerGroupId}
                                helperText={errors?.brokerGroupId?.message}
                            />
                        </Grid>
                        {/* <Grid container xs={12} sm={1} sx={{
                            justifyContent: "flex-end",
                            alignItems: "center",
                        }}>
                            <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />ثبت</Button>
                        </Grid> */}
                    </Grid>
                    <div style={{ overflowX: 'auto' }} dir='rtl'>
                        <table width={'100%'} cellSpacing={0} className='initialplantable'>
                            <tbody>
                                <tr style={{ background: "#f2f2f2" }}>
                                    <th colSpan="3">نام کارگزار</th>
                                    <th colSpan="2">شماره کارگزار</th>
                                    <th colSpan="1">شماره گروه</th>
                                    <th colSpan="1">شرکت مجری عربی </th>
                                    <th colSpan="1">تاریخ پرواز</th>
                                    <th colSpan="1">تاریخ نگارش</th>
                                </tr>
                                <tr style={{ background: "#f2f2f2" }}>
                                    <td colSpan="3">{BrokerInfo?.name}</td>
                                    <td colSpan="2">{BrokerInfo?.code}</td>
                                    <td colSpan="1">
                                        {/* <TextField id="outlined-basic" variant="outlined" {...register("groupNumber")} label="شماره گروه" style={{ width: 120 }} margin="normal" error={!!errors?.groupNumber}
helperText={errors?.groupNumber?.message}/>
                                         */}
                                        {
                                            tripInfoForPLan?.groupNo
                                        }
                                    </td>
                                    <td colSpan="1">
                                        {/* {HotelStructure?.companyName?.map((item) => (<div>
                                            {item}
                                        </div>))} */}
                                        {
                                            tripInfoForPLan?.companyName
                                        }
                                    </td>
                                    <td colSpan="1">
                                        {
                                            tripInfoForPLan?.persian_FlightDate
                                        }
                                        {/* <Controller
                                        control={control}
                                        name="flightDate"
                                        rules={{ required: true }} //optional
                                        render={({
                                            field: { onChange, name, value },
                                            fieldState: { invalid, isDirty }, //optional

                                        }) => (
                                            <>
                                                <DatePicker
                                                    value={value || ""}
                                                    onChange={(date) => {
                                                        onChange(date?.isValid ? date : "");
                                                    }}
                                                    format={"YYYY/MM/DD"}
                                                    calendar={persian}
                                                    locale={persian_fa}
                                                    calendarPosition="bottom-right"
                                                />

                                            </>
                                        )}
                                    />
                                          */}
                                    </td>
                                    <td colSpan="1">{CurrentDateTime}</td>
                                </tr>
                                <tr style={{ background: "#f8cbae" }}>
                                    <th>نام هتل</th>
                                    <th>شهر</th>
                                    <th>کد پلان</th>
                                    <th>گروه قیمتی</th>
                                    <th>ظرفیت</th>
                                    <th>اعزام روز</th>
                                    <th>تعداد کل اتاق</th>
                                    <th>ایستگاه پروازی</th>
                                    <th>هواپیمایی</th>
                                </tr>
                                <tr style={{ background: PlanInfoStructure?.colorCode }}>
                                    <td> {HotelStructure?.name}</td>
                                    <td>{CityInfo?.label}</td>
                                    <td>  {PlanInfoStructure?.planCode}</td>
                                    <td> {tripInfoForPLan?.priceGroupName}</td>
                                    <td>
                                        {/* <TextField type="number" id="outlined-basic" variant="outlined" {...register("capacity")} label="ظرفیت" style={{ width: 80 }} margin="normal" error={!!errors?.capacity}
                                        helperText={errors?.capacity?.message} /> */}
                                    </td>
                                    <td>
                                        {/* <RHFAutocomplete
                                        control={control}
                                        options={DispatchOfTheDayDropDown ?? []}
                                        name="dispatchOfTheDay"
                                        placeholder="اعزام روز"
                                        onChange={handleDispatchOfTheDayChanged}
                                        style={{
                                            width: 130,
                                            border: "none",
                                            padding: 0
                                        }}
                                    /> */}
                                    </td>
                                    <td>
                                        {PlanInfoStructure?.roomCount}
                                    </td>
                                    <td>
                                        {
                                            tripInfoForPLan?.originFlightStation
                                        }


                                    </td>
                                    <td>
                                        {tripInfoForPLan?.airLineName}
                                    </td>
                                </tr>
                                <tr>
                                    <th>آدرس</th>
                                    <td colSpan={8}>{HotelStructure?.address}
                                        <br />
                                        {HotelStructure?.arrabianAddress}
                                    </td>
                                </tr>
                                <tr>
                                    <th>تلفن</th>
                                    <td colSpan={1}>
                                        {HotelStructure?.phoneNumber}
                                    </td>
                                    <th colSpan={7}>مدیر محترم به کروکی مهندسی پیوست هنگام توزیع اتاق ها توجه گردد.</th>
                                </tr>
                                <tr>
                                    <td colSpan={9}>
                                        <table cellSpacing={0} className='innertable'>
                                            <tbody>
                                                {
                                                    PlanInfoStructure?.floors?.map((item) => (
                                                        <ChunkedPlanRooms item={item} colorCode={PlanInfoStructure?.colorCode} />
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan="3">توضیحات</th>
                                    <td colSpan={8}>
                                    {/* <TextField id="outlined-basic" variant="outlined" {...register("firstDescription")} fullWidth label="توضیحات 1" margin="normal" /> */}
                                    {PlanInfoStructure?.firstDescription}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={8}> 
                                        {/* <TextField id="outlined-basic" variant="outlined" {...register("secondDescription")} fullWidth label="توضیحات 2" margin="normal" /> */}
                                        {PlanInfoStructure?.secondDescription}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={8}>
                                        {/* <TextField id="outlined-basic" variant="outlined" {...register("thirdDescription")} fullWidth label="توضیحات 3" margin="normal" /> */}
                                        {PlanInfoStructure?.thirdDescription}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={11}>
                                        <InitialPlanFooter planInfo={PlanInfoStructure} countTreeBed={PlanInfoStructure?.countTreeBed} countTwoBed={PlanInfoStructure?.countTwoBed} countFourBed={PlanInfoStructure?.countFourBed} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </RtlProvider>
            </form>
        </Container>
    )
}
